import React from 'react'
import './Activity.css';
import ActivityCard from './ActivityCard';
import ActivityFilter from './ActivityFilter';
// import Container from '@material-ui/core/Container';
function Activity() {
    return (
        <div className="Activity">
            {/* <Container maxWidth="sm"> */}
            <div className="sectionHeader">
                <h1>Activity</h1>
                <ul className="activityFilter">
                    <ActivityFilter title = "Purchases"/>
                    <ActivityFilter title = "Sales"/>
                    <ActivityFilter title = "Transfers"/>
                    <ActivityFilter title = "Burns"/>
                    <ActivityFilter title = "Bids"/>
                    <ActivityFilter title = "Likes"/>
                    <ActivityFilter title = "Followings"/>
                </ul>
            </div>
            <div className="activityCards">
                <ul className="activityListItems">
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.09}
                        time = {1}
                    />
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.0049}
                        time = {20}
                    />
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.0409}
                        time = {35}
                    />
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.69}
                        time = {38}
                    />
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.039}
                        time = {40}
                    />
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.079}
                        time = {50}
                    />
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.079}
                        time = {52}
                    />
                    <ActivityCard 
                        imgesThumb = "http://dmitryvolkov.me/demo/unitok/img/cover/cover1.jpg"
                        username = "@sitamet"
                        title = "To Infinity And Beyond"
                        details = "Lorem ipsum dolor"
                        price = {0.079}
                        time = {53}
                    />
                </ul>
            </div>
            {/* </Container> */}
        </div>
    )
}

export default Activity
